import {createFeatureSelector, createSelector} from "@ngrx/store";
import {rolesFeatureKey, RolesState} from "../reducers/roles.reducer";

const rolesFeatureState = createFeatureSelector<RolesState>(rolesFeatureKey);

export const getRoles = createSelector(
  rolesFeatureState,
  state => state.roles ?? []
);
